import { render, staticRenderFns } from "./eventRemoteComponent.vue?vue&type=template&id=b9ba07a8&scoped=true&"
import script from "./eventRemoteComponent.vue?vue&type=script&lang=ts&"
export * from "./eventRemoteComponent.vue?vue&type=script&lang=ts&"
import style0 from "./eventRemoteComponent.vue?vue&type=style&index=0&id=b9ba07a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ba07a8",
  null
  
)

export default component.exports